import { render, staticRenderFns } from "./CheckOrCross.vue?vue&type=template&id=7dd881a0"
import script from "./CheckOrCross.vue?vue&type=script&lang=js"
export * from "./CheckOrCross.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports